import { render } from "./LoginWhiteImage.vue?vue&type=template&id=90cceade"
import script from "./LoginWhiteImage.vue?vue&type=script&lang=js"
export * from "./LoginWhiteImage.vue?vue&type=script&lang=js"

import "./LoginWhiteImage.vue?vue&type=style&index=0&id=90cceade&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__